import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { resolveEnterpriseNote} from "../../apis/enterprise-mapper-notes";

export function usePostResolveNote() {
  const queryClient = useQueryClient();

  const { data, error, mutate, status } = useMutation({
    mutationFn: ({
        noteId,
        businessId,
        businessAreaId,
    }: {
        noteId: number,
        businessId: string,
        businessAreaId: number,
    }) => {
      return resolveEnterpriseNote(
        noteId,
        businessId,
        businessAreaId,
        Storage.getCurrentUserToken() || "",
      );
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });
  return {
    data,
    error,
    mutate,
    status,
  };
}
